import { useEffect, useState } from "react";
import { Skeleton, Stack, TextField, Typography, styled } from "@mui/material";
import * as apiClient from "../api";
import { PatientDetailsWithId } from "../types";
import { DashboardPatientCard } from "../components";
import { useClinicianContext } from "../components/ClinicianContext";

const LoadingCard = styled(Skeleton)({
  height: "4rem",
});

const Dashboard = () => {
  const [patients, setPatients] = useState<PatientDetailsWithId[]>([]);
  const [clinician] = useClinicianContext();
  const [search, setSearch] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadPatients = async () => {
      const res = await apiClient.getSharedPatients(clinician.clinicianId);
      const patients = res.data.patients as PatientDetailsWithId[];
      setPatients(patients);
      setLoaded(true);
    };
    loadPatients();
  }, [clinician]);

  const bySearch = ({ firstName, lastName }: PatientDetailsWithId) => {
    const lowerSearch = search.toLowerCase();
    return search
      ? firstName.toLowerCase().includes(lowerSearch) ||
          lastName.toLowerCase().includes(lowerSearch) ||
          `${firstName} ${lastName}`.toLowerCase().includes(lowerSearch)
      : true;
  };

  const filteredPatients = patients.filter(bySearch);

  return (
    <Stack spacing={2}>
      <Typography variant="h4">Dashboard</Typography>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">Your patients</Typography>
        <TextField
          id="patients-search"
          label="Search"
          variant="outlined"
          type="search"
          autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Stack>
      {loaded ? (
        filteredPatients.length ? (
          filteredPatients.map((patient) => (
            <DashboardPatientCard key={patient.patientId} patient={patient} />
          ))
        ) : (
          <Typography textAlign="center">No patients found</Typography>
        )
      ) : (
        <>
          <LoadingCard variant="rounded" />
          <LoadingCard variant="rounded" />
          <LoadingCard variant="rounded" />
        </>
      )}
    </Stack>
  );
};

export default Dashboard;
